import { useEffect } from 'react'

export function usePageMeta({ title, description, canonical, image } = {}) {
  useEffect(() => {
    if (!title && !description) return undefined
    const previousTitle = document.title
    if (title) document.title = title

    const upsert = (selector, attrs) => {
      let el = document.head.querySelector(selector)
      if (!el) {
        el = document.createElement(attrs.tag || 'meta')
        if (attrs.name) el.setAttribute('name', attrs.name)
        if (attrs.property) el.setAttribute('property', attrs.property)
        if (attrs.rel) el.setAttribute('rel', attrs.rel)
        document.head.appendChild(el)
      }
      if (attrs.content) el.setAttribute('content', attrs.content)
      if (attrs.href) el.setAttribute('href', attrs.href)
      return el
    }

    if (description) {
      upsert('meta[name="description"]', {
        tag: 'meta',
        name: 'description',
        content: description,
      })
      upsert('meta[property="og:description"]', {
        tag: 'meta',
        property: 'og:description',
        content: description,
      })
      upsert('meta[name="twitter:description"]', {
        tag: 'meta',
        name: 'twitter:description',
        content: description,
      })
    }
    if (title) {
      upsert('meta[property="og:title"]', {
        tag: 'meta',
        property: 'og:title',
        content: title,
      })
      upsert('meta[name="twitter:title"]', {
        tag: 'meta',
        name: 'twitter:title',
        content: title,
      })
    }
    if (canonical) {
      upsert('link[rel="canonical"]', {
        tag: 'link',
        rel: 'canonical',
        href: canonical,
      })
    }
    if (image) {
      upsert('meta[property="og:image"]', {
        tag: 'meta',
        property: 'og:image',
        content: image,
      })
      upsert('meta[name="twitter:image"]', {
        tag: 'meta',
        name: 'twitter:image',
        content: image,
      })
    }

    return () => {
      document.title = previousTitle
    }
  }, [title, description, canonical, image])
}
